<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Genişletilmiş Siparişler ({{ richOrders.length }})</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="purple lighten-2" @click="openFraudModal" dark class="mr-2">
        <v-icon left>warning</v-icon>
        Fraud Emaili Hazırla
      </v-btn>
      <v-btn color="success" @click="openExcelModal" dark>
        <v-icon left>table_chart</v-icon>
        Excel Raporu Al
      </v-btn>
    </v-toolbar>

    <!-- Filters -->
    <v-container fluid class="pa-2">
      <v-layout wrap>
        <!-- Date Filters Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDate"
                    label="Başlangıç Tarihi"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  locale="tr-TR"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDate"
                    label="Bitiş Tarihi"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  locale="tr-TR"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-text-field
                v-model="searchQuery"
                @keyup.enter.native="search"
                label="Ara"
                clearable
                append-icon="search"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-btn color="primary" block @click="search" class="mt-3">
                <v-icon left>search</v-icon>
                Ara
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- Additional Filters Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox
                v-model="selectedOrderState"
                :items="this.$store.getters['orders/getStateItems']"
                item-value="id"
                item-text="value"
                label="Sipariş Durumu"
                @change="search"
                clearable
              ></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox
                v-model="selectedMpStatus"
                :items="this.$store.getters['orders/getHbStateItems']"
                item-value="id"
                item-text="value"
                label="MP Sipariş Durumu"
                @change="search"
                clearable
              ></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox
                v-model="selectedBank"
                :items="bankOptions"
                item-value="id"
                item-text="value"
                label="Banka Adı"
                @change="search"
                clearable
              ></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox
                v-model="selectedEligibility"
                :items="eligibilityOptions"
                item-value="id"
                item-text="value"
                label="Uygunluk Durumu"
                @change="search"
                clearable
              ></v-combobox>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Rich Orders Table -->
    <v-data-table
      :headers="headers"
      :items="richOrders"
      :loading="loading"
      :pagination.sync="pagination"
      :rows-per-page-items="pageItems"
      class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th
            v-for="header in props.headers"
            :key="header.text"
            class="px-1 text-xs-left"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small v-if="header.sortable !== false">arrow_upward</v-icon>
          </th>
        </tr>
      </template>

      <template v-slot:items="props">
        <tr :class="{ 
          'grey lighten-3': props.item.isLocked,
          'red--text': !props.item.isEligibleForCompletion,
          'purple lighten-5': props.item.isSentForFraud
        }">
          <td class="px-1">{{ props.item.orderDateTime | formatDate }}</td>
          <td class="px-1">{{ props.item.ibanMasked }}</td>
          <td class="px-1">{{ props.item.bankName || 'NULL' }}</td>
          <td class="px-1">
            <v-chip
              v-for="(note, index) in props.item.notes"
              :key="index"
              small
              :color="getNoteColor(note)"
              text-color="white"
              class="ma-1 square-chip"
            >
              {{ note }}
            </v-chip>
          </td>
          <td class="px-1">{{ props.item.orderGrams }}</td>
          <td class="px-1">{{ props.item.gramsToSendToBank.toFixed(4) }}</td>
          <td class="px-1">{{ props.item.orderNumber }}</td>
          <td class="px-1">{{ props.item.customerName }}</td>
          <td class="px-1">{{ props.item.productName }}</td>
          <td class="px-1">{{ props.item.quantity }}</td>
          <td class="px-1">{{ props.item.unitPrice | formatMoney }}</td>
          <td class="px-1">{{ props.item.invoiceAmount | formatMoney }}</td>
          <td class="px-1">{{ props.item.orderState | formatState }}</td>
          <td class="px-1">{{ props.item.mpOrderStatus | formatHbState }}</td>
          <td class="px-1">
            <v-btn
              small
              color="primary"
              @click="processOrder(props.item)"
              :disabled="props.item.isLocked"
            >
              İşlem Yap
            </v-btn>
            <span v-if="props.item.isLocked" class="caption grey--text ml-1">
              ({{ props.item.lockedByUserName || props.item.lockedByUser }})
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>

    <!-- Order Processing Modal -->
    <v-dialog v-model="orderDialog" max-width="1200px" @input="onDialogChange" persistent>
      <v-card v-if="currentOrders.length > 0" class="order-modal">
        <!-- Modern Header with Gradient -->
        <v-card-title class="headline white--text primary darken-1 elevation-2">
          <v-icon left color="white" size="28">receipt</v-icon>
          <span class="font-weight-bold">Sipariş Detayları</span>
          <v-spacer></v-spacer>
          
          <!-- Fraud Flag Switch -->
          <div v-if="anyItemSentForFraud" class="mr-4" style="display: flex; align-items: center;">
            <span class="mr-2 caption font-weight-bold">Fraud İşaretli</span>
            <v-switch
              v-model="fraudFlagActive"
              :disabled="!fraudFlagActive"
              @change="handleFraudSwitchChange"
              color="purple lighten-3"
              hide-details
              class="mt-0 pt-0"
            ></v-switch>
          </div>

          <v-btn 
            icon 
            dark 
            @click="closeModal"
            :loading="closeLoading"
            :disabled="shippingLoading"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container grid-list-md>
            <!-- Müşteri Bilgileri Section -->
            <v-card class="mb-4 elevation-2" outlined>
              <v-card-title class="subtitle-1 primary--text py-2">
                <v-icon left color="primary">person</v-icon>
                Müşteri Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6 class="py-2">
                    <div class="caption grey--text">Müşteri Adı</div>
                    <div class="body-2 font-weight-medium">{{ currentOrders[0].customerName }}</div>
                  </v-flex>
                  <v-flex xs12 sm6 class="py-2">
                    <div class="caption grey--text">Sipariş No</div>
                    <div class="body-2 font-weight-medium">{{ currentOrders[0].orderNumber }}</div>
                  </v-flex>
                  <v-flex xs12 sm6 class="py-2">
                    <div class="caption grey--text">Sipariş Tarihi</div>
                    <div class="body-2">{{ currentOrders[0].orderDateTime | formatDate }}</div>
                  </v-flex>
                  <v-flex xs12 sm6 class="py-2">
                    <div class="caption grey--text">Tamamlanabilme Durumu</div>
                    <div :class="!isOrderEligibleForCompletion ? 'body-2 red--text font-weight-bold' : 'body-2 success--text font-weight-bold'">{{ isOrderEligibleForCompletion ? 'UYGUN' : 'UYGUN DEĞİL' }}</div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <!-- IBAN Bazlı Gruplar -->
            <v-card 
              v-for="(group, groupIndex) in groupedOrders" 
              :key="groupIndex"
              class="mb-4 elevation-2" 
              outlined
            >
              <!-- Banka Bilgileri -->
              <v-card-title :class="!isOrderEligibleForCompletion ? 'subtitle-1 red--text py-2' : 'subtitle-1 primary--text py-2'">
                <v-icon left :color="!isOrderEligibleForCompletion ? 'red' : 'primary'">account_balance</v-icon>
                Banka Bilgileri
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4 class="py-2">
                    <div class="caption grey--text">Banka Adı</div>
                    <div class="body-2">{{ group.bankName || 'Bulunamadı' }}</div>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="py-2">
                    <div class="caption grey--text">IBAN</div>
                    <div 
                      :class="!isOrderEligibleForCompletion ? 'body-2 red--text font-weight-bold clickable-iban' : 'body-2 success--text font-weight-bold clickable-iban'"
                      @click="copyIbanToClipboard(group.iban)"
                      :title="'IBAN\'ı kopyalamak için tıklayın: ' + group.iban"
                    >
                      <v-icon small class="mr-1">content_copy</v-icon>
                      {{ group.iban }}
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="py-2">
                    <div class="caption grey--text">Toplam Gönderilecek Altın Gramı</div>
                    <div :class="!isOrderEligibleForCompletion ? 'body-2 red--text font-weight-bold' : 'body-2 success--text font-weight-bold'">
                      {{ !isOrderEligibleForCompletion ? '0.00' : group.totalGramsToSend.toFixed(2) }} gr
                    </div>
                  </v-flex>
                  <v-flex xs12 v-if="!isOrderEligibleForCompletion">
                    <v-alert 
                      color="error" 
                      dense
                      border="left"
                      colored-border
                      class="mt-3 mb-0 white--text"
                      style="background-color: #f44336 !important;"
                    >
                      <strong>⚠ Bu sipariş tamamlanmaya uygun değildir.</strong>
                    </v-alert>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <!-- Her item için Ürün ve Tutar Bilgileri -->
              <div v-for="(item, itemIndex) in group.items" :key="'item-' + groupIndex + '-' + itemIndex">
                <v-divider class="mx-4"></v-divider>
                <v-card-title class="subtitle-1 primary--text py-2">
                  <v-icon left color="primary">shopping_cart</v-icon>
                  Ürün ve Tutar Bilgileri {{ group.items.length > 1 ? '(' + (itemIndex + 1) + ')' : '' }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 class="py-2">
                      <div class="caption grey--text">Ürün</div>
                      <div class="body-2 font-weight-medium">{{ item.productName }}</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Miktar</div>
                      <div class="body-2">{{ item.quantity }} adet</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Ürün Gram</div>
                      <div class="body-2">{{ item.orderGrams }} gr</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Bankaya Gönderilecek</div>
                      <div class="body-2">{{ item.gramsToSendToBank.toFixed(4) }} gr</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Birim Fiyat</div>
                      <div class="body-2">{{ item.unitPrice | formatMoney }}</div>
                    </v-flex>
                    <v-flex xs12 sm6 md4 class="py-2">
                      <div class="caption grey--text">Fatura Tutarı</div>
                      <div class="body-2">{{ item.invoiceAmount | formatMoney }}</div>
                    </v-flex>
                    <v-flex xs12 class="py-2">
                      <div class="caption grey--text mb-2">Notlar</div>
                      <div
                        v-for="(note, noteIndex) in item.notes"
                        :key="noteIndex"
                        :class="note.includes('Anlaşmalı Banka') && !note.includes('Değil') ? 'green--text' : 'red--text'"
                        class="body-2 font-weight-medium mb-1"
                      >
                        • {{ note }}
                      </div>
                    </v-flex>

                    <!-- Yeni IBAN Tanımla Section - Sadece not eligible itemlar için -->
                    <v-flex xs12 v-if="!item.isEligibleForCompletion" class="py-2 mt-3">
                      <v-divider class="mb-3"></v-divider>
                      <div v-if="!ibanUpdateState[item.orderItemId] || !ibanUpdateState[item.orderItemId].showInput">
                        <v-btn
                          small
                          color="warning"
                          @click="showIbanInput(item.orderItemId)"
                        >
                          <v-icon left small>edit</v-icon>
                          Yeni IBAN Tanımla
                        </v-btn>
                      </div>
                      <div v-else>
                        <v-text-field
                          v-model="ibanUpdateState[item.orderItemId].newIban"
                          label="Yeni IBAN"
                          outlined
                          dense
                          maxlength="26"
                          counter
                          :disabled="ibanUpdateState[item.orderItemId].loading"
                          @keyup.enter="updateItemIban(item)"
                        ></v-text-field>
                        <v-btn
                          small
                          color="success"
                          @click="updateItemIban(item)"
                          :loading="ibanUpdateState[item.orderItemId].loading"
                          :disabled="ibanUpdateState[item.orderItemId].loading"
                          class="mr-2"
                        >
                          <v-icon left small>check</v-icon>
                          Tamam
                        </v-btn>
                        <v-btn
                          small
                          color="grey"
                          text
                          @click="ibanUpdateState[item.orderItemId].showInput = false"
                          :disabled="ibanUpdateState[item.orderItemId].loading"
                        >
                          İptal
                        </v-btn>
                      </div>
                    </v-flex>

                    <!-- Order Item Notes Section -->
                    <v-flex xs12 class="py-2 mt-3">
                      <v-divider class="mb-3"></v-divider>
                      
                      <!-- Display existing note -->
                      <div v-if="item.orderItemNotes && (!notesUpdateState[item.orderItemId] || !notesUpdateState[item.orderItemId].showTextarea)">
                        <div class="subtitle-2 primary--text mb-2">
                          <v-icon small color="primary" class="mr-1">note</v-icon>
                          Sipariş Kalemi Notu
                        </div>
                        <div style="position: relative;">
                          <v-card outlined class="pa-3 note-display-card">
                            <div class="body-2" style="padding-right: 32px;">{{ item.orderItemNotes }}</div>
                          </v-card>
                          <v-btn
                            icon
                            small
                            color="primary"
                            class="note-edit-btn"
                            @click="showNotesTextarea(item.orderItemId, item.orderItemNotes)"
                          >
                            <v-icon small>edit</v-icon>
                          </v-btn>
                        </div>
                      </div>

                      <!-- Add note button -->
                      <div v-if="!item.orderItemNotes && (!notesUpdateState[item.orderItemId] || !notesUpdateState[item.orderItemId].showTextarea)">
                        <div class="subtitle-2 grey--text mb-2">
                          <v-icon small color="grey" class="mr-1">note</v-icon>
                          Sipariş Kalemi Notu
                        </div>
                        <v-btn
                          small
                          color="info"
                          outlined
                          @click="showNotesTextarea(item.orderItemId, '')"
                        >
                          <v-icon left small>add</v-icon>
                          Not Ekle
                        </v-btn>
                      </div>

                      <!-- Textarea for editing -->
                      <div v-if="notesUpdateState[item.orderItemId] && notesUpdateState[item.orderItemId].showTextarea">
                        <div class="subtitle-2 primary--text mb-2">
                          <v-icon small color="primary" class="mr-1">edit_note</v-icon>
                          Not Düzenle
                        </div>
                        <v-textarea
                          v-model="notesUpdateState[item.orderItemId].notes"
                          outlined
                          dense
                          rows="4"
                          maxlength="500"
                          counter
                          :disabled="notesUpdateState[item.orderItemId].loading"
                          placeholder="Notunuzu buraya yazın..."
                        ></v-textarea>
                        <v-btn
                          small
                          color="success"
                          @click="updateItemNotes(item)"
                          :loading="notesUpdateState[item.orderItemId].loading"
                          :disabled="notesUpdateState[item.orderItemId].loading"
                          class="mr-2"
                        >
                          <v-icon left small>save</v-icon>
                          Kaydet
                        </v-btn>
                        <v-btn
                          small
                          color="grey"
                          text
                          class="white--text"
                          @click="notesUpdateState[item.orderItemId].showTextarea = false"
                          :disabled="notesUpdateState[item.orderItemId].loading"
                        >
                          İptal
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </div>
            </v-card>
          </v-container>
        </v-card-text>

        <!-- Action Buttons -->
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-card
            v-if="canCompleteOrder"
            outlined
            class="pa-3 mr-4"
            style="min-width: 360px; max-width: 420px; border: 2px dashed rgba(33, 150, 243, 0.6); background: rgba(33, 150, 243, 0.05);"
          >
            <div class="d-flex align-center mb-2">
              <v-icon color="primary" class="mr-2">payments</v-icon>
              <span class="subtitle-2 font-weight-bold">Banka Nakit Düşümü</span>
              <v-spacer></v-spacer>
              <span class="caption red--text font-weight-bold">*</span>
            </div>
            <v-text-field
              v-model.number="bankCashDeductionAmount"
              label="Düşülecek Tutar"
              placeholder="Örn: 123,58"
              type="number"
              step="0.01"
              min="-1"
              :disabled="shippingLoading || closeLoading"
              :rules="cashDeductionRules"
              hide-details="auto"
              dense
              outlined
              color="primary"
              prepend-inner-icon="payments"
              suffix="₺"
              hint="Tamamla butonuna basmadan önce düşülecek TL tutarını giriniz."
              persistent-hint
            ></v-text-field>
          </v-card>
          <v-spacer></v-spacer>
          <v-btn 
            color="grey" 
            text
            @click="closeModal"
            :loading="closeLoading"
            :disabled="shippingLoading"
            class="px-4 white--text"
          >
            <v-icon left>close</v-icon>
            Kapat
          </v-btn>
          <v-btn 
            :color="(!isOrderEligibleForCompletion || anyItemSentForFraud || !isOrderStateNewOrder) ? 'error' : 'success'" 
            depressed
            @click="setShippingStatus"
            :loading="shippingLoading"
            :disabled="closeLoading || !canCompleteOrder || !isCashDeductionValid"
            class="px-4"
          >
            <v-icon left>{{ (!isOrderEligibleForCompletion || anyItemSentForFraud || !isOrderStateNewOrder) ? 'block' : 'local_shipping' }}</v-icon>
            {{ (!isOrderEligibleForCompletion || anyItemSentForFraud || !isOrderStateNewOrder) ? 'Tamamlanamaz' : 'Tamamla' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Fraud Orders Modal -->
    <v-dialog v-model="fraudDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title class="headline white--text purple lighten-2 elevation-2">
          <v-icon left color="white" size="28">warning</v-icon>
          <span class="font-weight-bold">Fraud Kontrol - Şüpheli Siparişler</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeFraudModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-container v-if="fraudLoading" class="text-center py-5">
            <v-progress-circular
              indeterminate
              color="primary"
              size="64"
            ></v-progress-circular>
            <div class="mt-3 title">Siparişler kontrol ediliyor...</div>
          </v-container>

          <v-container v-else-if="!fraudLoading && (!fraudOrders || fraudOrders.length === 0)">
            <div style="background: #e8f5e9; border-left: 4px solid #4caf50; padding: 24px; margin: 16px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; margin-bottom: 12px;">
                <v-icon large color="success" style="margin-right: 12px;">check_circle</v-icon>
                <h2 style="color: #2e7d32; margin: 0; font-size: 24px; font-weight: 500;">Şüpheli sipariş bulunamadı</h2>
              </div>
              <p style="color: #1b5e20; font-size: 16px; margin: 8px 0 8px 48px;">
                Tüm siparişler normal limitlerin içerisinde.
              </p>
              <p style="color: #66bb6a; font-size: 14px; margin: 4px 0 0 48px;">
                Fraud kontrolü tamamlandı.
              </p>
            </div>
          </v-container>

          <v-container v-else-if="!fraudLoading && fraudOrders && fraudOrders.length > 0">
            <div style="background: #fff3e0; border-left: 4px solid #ff9800; padding: 20px; margin-bottom: 10px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; margin-bottom: 8px;">
                <v-icon large color="warning" style="margin-right: 12px;">warning</v-icon>
                <h2 style="color: #e65100; margin: 0; font-size: 22px; font-weight: 500;">{{ fraudOrders.length }} adet şüpheli sipariş tespit edildi!</h2>
              </div>
              <p style="color: #ef6c00; font-size: 15px; margin: 4px 0 0 48px;">
                Aşağıdaki siparişler belirlenen limiti aşmaktadır.
              </p>
            </div>

            <v-data-table
              :headers="fraudHeaders"
              :items="fraudOrders"
              :rows-per-page-items="[10, 25, 50]"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="px-1">{{ props.item.orderNumber }}</td>
                  <td class="px-1 error--text font-weight-bold">{{ props.item.totalAmount | formatMoney }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeFraudModal" class="px-4 white--text">
            <v-icon left>close</v-icon>
            Kapat
          </v-btn>
          <v-btn 
            v-if="!emailPrepared && fraudOrders.length > 0"
            color="primary" 
            depressed
            @click="prepareEmail"
            class="px-4"
          >
            <v-icon left>email</v-icon>
            Email'i Hazırla
          </v-btn>
          <v-btn 
            v-if="emailPrepared"
            color="success" 
            depressed
            @click="markAsSent"
            class="px-4"
          >
            <v-icon left>check</v-icon>
            Email'i Yolladım
          </v-btn>
          <v-btn 
            v-if="emailPrepared"
            color="warning" 
            text
            @click="emailPrepared = false"
            class="px-4"
          >
            <v-icon left>close</v-icon>
            Email'i Yollamadım
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Excel Export Modal -->
    <v-dialog v-model="excelDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline white--text success elevation-2">
          <v-icon left color="white" size="28">table_chart</v-icon>
          <span class="font-weight-bold">Excel Raporu</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeExcelModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-container>
            <v-layout wrap>
              <v-flex xs12 class="mb-3">
                <v-menu
                  v-model="excelStartDateMenu"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="excelStartDate"
                      label="Başlangıç Tarihi"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="excelStartDate"
                    locale="tr-TR"
                    @input="excelStartDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12>
                <v-menu
                  v-model="excelEndDateMenu"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="excelEndDate"
                      label="Bitiş Tarihi"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="excelEndDate"
                    locale="tr-TR"
                    @input="excelEndDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeExcelModal" class="px-4">
            <v-icon left>close</v-icon>
            İptal
          </v-btn>
          <v-btn 
            color="success" 
            depressed
            @click="exportToExcel"
            :disabled="!excelStartDate || !excelEndDate"
            :loading="excelLoading"
            class="px-4"
          >
            <v-icon left>cloud_download</v-icon>
            Excel'e Aktar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      searchQuery: '',
      selectedOrderState: { id: -1, value: 'Tümü' },
      selectedMpStatus: { id: '', value: 'Tümü' },
      selectedBank: { id: '-1', value: 'Tümü' },
      selectedEligibility: { id: 'all', value: 'Tümü' },
      loading: false,
      orderDialog: false,
      fraudDialog: false,
      fraudOrders: [],
      fraudLoading: false,
      emailPrepared: false,
      fraudHeaders: [
        { text: 'Sipariş Numarası', value: 'orderNumber' },
        { text: 'Toplam Tutar', value: 'totalAmount' },
      ],
      excelDialog: false,
      excelStartDate: null,
      excelEndDate: null,
      excelStartDateMenu: false,
      excelEndDateMenu: false,
      excelLoading: false,
      currentOrders: [],
      refreshInterval: null,
      shippingLoading: false,
      closeLoading: false,
      bankCashDeductionAmount: null,
      cashDeductionRules: [
        v => (v !== null && v !== undefined && v !== '') || 'Nakit düşümü zorunludur',
        v => (Number(v) >= 0) || 'Nakit düşümü 0’dan düşük olamaz'
      ],
      fraudFlagActive: false,
      ibanUpdateState: {}, // { orderItemId: { showInput: false, newIban: '', loading: false } }
      notesUpdateState: {}, // { orderItemId: { showTextarea: false, notes: '', loading: false } }
      pagination: {
        sortBy: 'orderDateTime',
        descending: true
      },
      pageItems: [
        25,
        50,
        100,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
      ],
      bankOptions: [
        { id: '-1', value: 'Tümü' }
      ],
      eligibilityOptions: [
        { id: 'all', value: 'Tümü' },
        { id: 'eligible', value: 'Uygun' },
        { id: 'not-eligible', value: 'Uygun Değil' }
      ],
      headers: [
        { text: 'Sipariş Tarihi ve Saati', value: 'orderDateTime' },
        { text: 'IBAN', value: 'ibanMasked' },
        { text: 'Banka', value: 'bankName' },
        { text: 'Notlar', value: 'notes', sortable: false },
        { text: 'Sipariş Gram', value: 'orderGrams' },
        { text: 'Bankaya Gönderilecek Gram', value: 'gramsToSendToBank' },
        { text: 'Sipariş No', value: 'orderNumber' },
        { text: 'Müşteri Adı', value: 'customerName' },
        { text: 'Ürün Adı', value: 'productName' },
        { text: 'Miktar', value: 'quantity' },
        { text: 'Birim Fiyat', value: 'unitPrice' },
        { text: 'Fatura Tutarı', value: 'invoiceAmount' },
        { text: 'Sipariş Durumu', value: 'orderState' },
        { text: 'MP Sipariş Durumu', value: 'mpOrderStatus' },
        { text: 'İşlem', value: 'action', sortable: false },
      ]
    };
  },
  computed: {
    richOrders() {
      return this.$store.getters['richOrders/richOrders'];
    },
    isOrderEligibleForCompletion() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return true;
      }
      // En az bir item uygun değilse, sipariş tamamlanamaz
      return this.currentOrders.every(order => order.isEligibleForCompletion);
    },
    groupedOrders() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return [];
      }

      // IBAN'a göre grupla
      const groups = {};
      this.currentOrders.forEach(order => {
        const iban = order.ibanFull || 'UNKNOWN';
        if (!groups[iban]) {
          groups[iban] = {
            iban: order.ibanFull,
            ibanMasked: order.ibanMasked,
            bankName: order.bankName,
            customerName: order.customerName,
            orderDateTime: order.orderDateTime,
            orderNumber: order.orderNumber,
            items: []
          };
        }
        groups[iban].items.push(order);
      });

      // Array'e çevir ve toplam gramları hesapla
      return Object.values(groups).map(group => ({
        ...group,
        totalGramsToSend: group.items.reduce((sum, item) => sum + item.gramsToSendToBank, 0)
      }));
    },
    anyItemSentForFraud() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return false;
      }
      return this.currentOrders.some(order => order.isSentForFraud);
    },
    
    isOrderStateNewOrder() {
      if (!this.currentOrders || this.currentOrders.length === 0) {
        return false;
      }
      // Sipariş state'i 0 (Yeni Sipariş) olmalı
      return this.currentOrders[0].orderState === 0;
    },

    canCompleteOrder() {
      return this.isOrderEligibleForCompletion && !this.anyItemSentForFraud && this.isOrderStateNewOrder;
    },

    isCashDeductionValid() {
      const hasValue =
        this.bankCashDeductionAmount !== null &&
        this.bankCashDeductionAmount !== undefined &&
        this.bankCashDeductionAmount !== '';
      if (!hasValue) return false;
      return Number(this.bankCashDeductionAmount) >= 0;
    }
  },
  async mounted() {
    await this.loadBanks();
    await this.search();
  },
  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    async search() {
      this.loading = true;
      try {
        let isEligibleForCompletion = null;
        if (this.selectedEligibility && this.selectedEligibility.id === 'eligible') {
          isEligibleForCompletion = true;
        } else if (this.selectedEligibility && this.selectedEligibility.id === 'not-eligible') {
          isEligibleForCompletion = false;
        }

        const searchDto = {
          startDate: this.startDate,
          endDate: this.endDate,
          searchQuery: this.searchQuery,
          orderState: this.selectedOrderState && this.selectedOrderState.id !== -1 ? this.selectedOrderState.id : null,
          mpOrderStatus: this.selectedMpStatus && this.selectedMpStatus.id ? this.selectedMpStatus.id : null,
          bankName: this.selectedBank && this.selectedBank.id !== '-1' ? this.selectedBank.id : null,
          isEligibleForCompletion: isEligibleForCompletion
        };
        await this.$store.dispatch('richOrders/searchRichOrders', searchDto);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error searching rich orders:', error);
        this.$store.state.dialog = true;
        this.$store.state.message = 'Arama sırasında bir hata oluştu.';
      } finally {
        this.loading = false;
      }
    },

    async processOrder(order) {
      try {
        const orderDetails = await this.$store.dispatch('richOrders/lockOrder', order.orderNumber);
        this.currentOrders = orderDetails;
        // Check if any item is sent for fraud
        this.fraudFlagActive = orderDetails.some(item => item.isSentForFraud);
        this.bankCashDeductionAmount = null;
        this.orderDialog = true;
      } catch (error) {
        this.$store.state.dialog = true;
        // Backend'den gelen hata mesajı zaten userName içeriyor
        this.$store.state.message = (error.response && error.response.data && error.response.data.message) || 'Bu sipariş başka bir kullanıcı tarafından işlem görüyor.';
      }
    },

    async closeModal() {
      if (this.currentOrders && this.currentOrders.length > 0) {
        this.closeLoading = true;
        try {
          await this.$store.dispatch('richOrders/unlockOrder', this.currentOrders[0].orderNumber);
          await this.search(); // Refresh to update lock status
          this.currentOrders = [];
        } catch (error) {
          this.$store.state.dialog = true;
          this.$store.state.message = 'Modal kapatılırken bir hata oluştu.';
        } finally {
          this.closeLoading = false;
          this.orderDialog = false;
          this.bankCashDeductionAmount = null;
        }
      }
    },
    
    onDialogChange(val) {
      if (!val && this.currentOrders && this.currentOrders.length > 0) {
        this.closeModal();
      }
    },

    async loadBanks() {
      try {
        await this.$store.dispatch('richOrders/loadActiveBanks');
        const activeBanks = this.$store.getters['richOrders/activeBanks'];
        this.bankOptions = [
          { id: '-1', value: 'Tümü' },
          ...activeBanks.map(b => ({ id: b.bankName, value: b.bankName }))
        ];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading banks:', error);
      }
    },

    getNoteColor(note) {
      if (note.includes('Anlaşmalı Banka') && !note.includes('Değil')) return 'green';
      return 'grey';
    },

    async copyIbanToClipboard(iban) {
      try {
        await navigator.clipboard.writeText(iban);
        this.$store.state.dialog = true;
        this.$store.state.message = `IBAN kopyalandı: ${iban}`;
      } catch (error) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = iban;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$store.state.dialog = true;
          this.$store.state.message = `IBAN kopyalandı: ${iban}`;
        } catch (err) {
          this.$store.state.dialog = true;
          this.$store.state.message = 'IBAN kopyalanamadı. Lütfen manuel olarak kopyalayın.';
        }
        document.body.removeChild(textArea);
      }
    },
    
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    async setShippingStatus() {
      if (!this.currentOrders || this.currentOrders.length === 0) return;

      if (!this.isCashDeductionValid) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Tamamlamak için "Nakit Düşümü (TL)" alanını doldurunuz.';
        return;
      }
      
      this.shippingLoading = true;
      try {
        const poolOrders = this.currentOrders.map(order => ({
          id: order.id,
          indicator: 0,
          orderDate: order.orderDateTime,
          identityNo: '',
          shipmentNo: order.orderNumber,
          recipientName: order.customerName,
          productName: order.productName,
          quantity: order.quantity,
          amount: order.unitPrice,
          totalAmount: order.invoiceAmount,
          barcode: '',
          iban: order.ibanFull
        }));

        await this.$store.dispatch('richOrders/completeBulkOrder', poolOrders);

        const bankName = this.currentOrders[0].bankName;
        const cashAmount = Number(this.bankCashDeductionAmount);
        const updated = await this.$store.dispatch('partnerBanks/cashAmountUpdate', { bankName, cashAmount });
        if (!updated) {
          throw new Error('Bank cash amount update failed.');
        }
        
        await this.$store.dispatch('richOrders/unlockOrder', this.currentOrders[0].orderNumber);
        await this.search();
        
        this.$store.state.dialog = true;
        this.$store.state.message = 'Sipariş başarıyla tamamlandı.';
        
        this.currentOrders = [];
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = (error.response && error.response.data && error.response.data.message) || 'Sipariş tamamlanırken bir hata oluştu.';
      } finally {
        this.shippingLoading = false;
        this.orderDialog = false;
        this.bankCashDeductionAmount = null;
      }
    },

    initIbanUpdateState(orderItemId) {
      if (!this.ibanUpdateState[orderItemId]) {
        this.$set(this.ibanUpdateState, orderItemId, {
          showInput: false,
          newIban: '',
          loading: false
        });
      }
    },

    showIbanInput(orderItemId) {
      this.initIbanUpdateState(orderItemId);
      this.ibanUpdateState[orderItemId].showInput = true;
    },

    async updateItemIban(item) {
      const orderItemId = item.orderItemId;
      this.initIbanUpdateState(orderItemId);
      
      const state = this.ibanUpdateState[orderItemId];
      const newIban = state.newIban.trim();

      if (!newIban) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Lütfen yeni IBAN giriniz.';
        return;
      }

      if (newIban.length !== 26) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'IBAN 26 karakter olmalıdır.';
        return;
      }

      state.loading = true;
      try {
        await this.$store.dispatch('richOrders/updateOrderItemIban', {
          orderItemId,
          newIban
        });

        this.$store.state.dialog = true;
        this.$store.state.message = 'IBAN başarıyla güncellendi.';

        // Modal'ı kapat ve rich order'ı tekrar yükle
        const orderNumber = this.currentOrders[0].orderNumber;
        await this.$store.dispatch('richOrders/unlockOrder', orderNumber);
        await this.search();
        
        // Modal'ı tekrar aç
        const orderDetails = await this.$store.dispatch('richOrders/lockOrder', orderNumber);
        this.currentOrders = orderDetails;
        this.ibanUpdateState = {}; // Reset state
        
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = (error.response && error.response.data && error.response.data.message) || 'IBAN güncellenirken bir hata oluştu.';
      } finally {
        state.loading = false;
      }
    },

    initNotesUpdateState(orderItemId) {
      if (!this.notesUpdateState[orderItemId]) {
        this.$set(this.notesUpdateState, orderItemId, {
          showTextarea: false,
          notes: '',
          loading: false
        });
      }
    },

    showNotesTextarea(orderItemId, currentNotes) {
      this.initNotesUpdateState(orderItemId);
      this.notesUpdateState[orderItemId].notes = currentNotes || '';
      this.notesUpdateState[orderItemId].showTextarea = true;
    },

    async updateItemNotes(item) {
      const orderItemId = item.orderItemId;
      this.initNotesUpdateState(orderItemId);
      
      const state = this.notesUpdateState[orderItemId];
      const notes = state.notes.trim();

      state.loading = true;
      try {
        await this.$store.dispatch('richOrders/updateOrderItemNotes', {
          orderItemId,
          notes
        });

        this.$store.state.dialog = true;
        this.$store.state.message = 'Not başarıyla kaydedildi.';

        // Modal'ı kapat ve rich order'ı tekrar yükle
        const orderNumber = this.currentOrders[0].orderNumber;
        await this.$store.dispatch('richOrders/unlockOrder', orderNumber);
        await this.search();
        
        // Modal'ı tekrar aç
        const orderDetails = await this.$store.dispatch('richOrders/lockOrder', orderNumber);
        this.currentOrders = orderDetails;
        this.notesUpdateState = {}; // Reset state
        
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = (error.response && error.response.data && error.response.data.message) || 'Not kaydedilirken bir hata oluştu.';
      } finally {
        state.loading = false;
      }
    },

    async openFraudModal() {
      this.fraudDialog = true;
      this.fraudLoading = true;
      this.emailPrepared = false;
      this.fraudOrders = [];
      try {
        this.fraudOrders = await this.$store.dispatch('richOrders/getFraudOrders');
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Fraud siparişleri yüklenirken bir hata oluştu.';
        // eslint-disable-next-line no-console
        console.error('Error loading fraud orders:', error);
      } finally {
        this.fraudLoading = false;
      }
    },

    closeFraudModal() {
      this.fraudDialog = false;
      this.fraudOrders = [];
      this.fraudLoading = false;
      this.emailPrepared = false;
    },

    openExcelModal() {
      this.excelDialog = true;
      // Set default dates to today
      const today = new Date().toISOString().substr(0, 10);
      this.excelStartDate = today;
      this.excelEndDate = today;
    },

    closeExcelModal() {
      this.excelDialog = false;
      this.excelStartDate = null;
      this.excelEndDate = null;
      this.excelLoading = false;
    },

    async exportToExcel() {
      if (!this.excelStartDate || !this.excelEndDate) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Lütfen başlangıç ve bitiş tarihlerini seçin.';
        return;
      }

      this.excelLoading = true;
      try {
        const data = await this.$store.dispatch('richOrders/getCompletedOrdersForExport', {
          startDate: this.excelStartDate,
          endDate: this.excelEndDate
        });

        if (!data || data.length === 0) {
          this.$store.state.dialog = true;
          this.$store.state.message = 'Seçilen tarih aralığında tamamlanmış sipariş bulunamadı.';
          return;
        }

        // Excel export için XLSX kütüphanesini kullan
        const XLSX = require('xlsx');
        
        // Verileri Excel formatına dönüştür
        const excelData = data.map(item => ({
          'Sipariş Tarihi': new Date(item.orderDateTime).toLocaleString('tr-TR'),
          'Tamamlanma Tarihi': item.completedDate ? new Date(item.completedDate).toLocaleString('tr-TR') : '',
          'Sipariş Numarası': item.orderNumber,
          'Müşteri Adı': item.customerName,
          'IBAN': item.ibanFull,
          'Banka': item.bankName || '',
          'Ürün Adı': item.productName,
          'Miktar': item.quantity,
          'Sipariş Gram': item.orderGrams,
          'Bankaya Gönderilecek Gram': parseFloat(item.gramsToSendToBank).toFixed(2),
          'Birim Fiyat': item.unitPrice,
          'Fatura Tutarı': item.invoiceAmount,
          'Sipariş Durumu': this.getStateValue(item.orderState),
          'MP Sipariş Durumu': this.getMpOrderStatusValue(item.mpOrderStatus)
        }));

        // Worksheet ve Workbook oluştur
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Siparişler');

        // Dosya adını oluştur
        const fileName = `Siparis_Raporu_${this.excelStartDate}_${this.excelEndDate}.xlsx`;

        // Excel dosyasını indir
        XLSX.writeFile(wb, fileName);

        this.$store.state.dialog = true;
        this.$store.state.message = 'Excel raporu başarıyla oluşturuldu.';
        this.closeExcelModal();

      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Excel raporu oluşturulurken bir hata oluştu.';
        // eslint-disable-next-line no-console
        console.error('Error exporting to Excel:', error);
      } finally {
        this.excelLoading = false;
      }
    },

    prepareEmail() {
      if (this.fraudOrders.length === 0) return;

      const orderNumbers = this.fraudOrders.map(fo => fo.orderNumber).join('\n');
      const subject = 'Kontrol edilecek siparişler';
      const body = `Merhaba,\n\nAşağıdaki sipariş numaralarının kontrol edilmesi gerekmektedir:\n\n${orderNumbers}\n\nTeşekkürler.`;
      
      const mailtoLink = `mailto:fraud@hepsiburada.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink;
      
      this.emailPrepared = true;
    },

    async markAsSent() {
      try {
        // Use plain string array to avoid any Vue reactivity issues
        const orderNumbers = [];
        for (let i = 0; i < this.fraudOrders.length; i++) {
          orderNumbers.push(this.fraudOrders[i].orderNumber);
        }
                
        // Call API directly to avoid store issues
        const richOrdersApi = require('@/api/richOrders').default;
        await richOrdersApi.markFraudSent(orderNumbers);
        
        this.$store.state.dialog = true;
        this.$store.state.message = 'Siparişler fraud olarak işaretlendi.';
        
        this.closeFraudModal();
        await this.search(); // Refresh the list
      } catch (error) {
        this.$store.state.dialog = true;
        const errorMessage = (error.response && error.response.data && error.response.data.message) 
          ? error.response.data.message 
          : 'Siparişler işaretlenirken bir hata oluştu.';
        this.$store.state.message = errorMessage;
        // eslint-disable-next-line no-console
        console.error('Error marking orders as sent for fraud:', error);
        // eslint-disable-next-line no-console
        console.error('Error response:', error.response);
      }
    },

    async handleFraudSwitchChange(value) {
      // value false ise (switch kapatıldı), fraud flag'i temizle
      if (!value) {
        try {
          const orderNumber = this.currentOrders[0].orderNumber;
          // eslint-disable-next-line no-console
          console.log('Clearing fraud flag for orderNumber:', orderNumber, 'Type:', typeof orderNumber);
          
          // Backend'e fraud flag temizleme isteği gönder
          await this.$store.dispatch('richOrders/clearFraudFlag', orderNumber);
          
          this.$store.state.dialog = true;
          this.$store.state.message = 'Fraud işareti kaldırıldı.';
          
          // Modal'ı kapat ve siparişi tekrar aç (refresh için)
          await this.$store.dispatch('richOrders/unlockOrder', orderNumber);
          await this.search();
          
          // Siparişi tekrar kilitle ve modal'ı aç
          const orderDetails = await this.$store.dispatch('richOrders/lockOrder', orderNumber);
          this.currentOrders = orderDetails;
          this.fraudFlagActive = false;
          
        } catch (error) {
          this.$store.state.dialog = true;
          this.$store.state.message = 'Fraud işareti kaldırılırken bir hata oluştu.';
          // eslint-disable-next-line no-console
          console.error('Error clearing fraud flag:', error);
          // Switch'i geri aç
          this.fraudFlagActive = true;
        }
      }
    },

    getStateValue(stateId) {
      const stateMap = {
        0: 'Yeni Sipariş',
        1: 'İşleniyor',
        2: 'Tamamlandı',
        3: 'İptal Edildi',
        4: 'İade'
      };
      return stateMap[stateId] || stateId.toString();
    },

    getMpOrderStatusValue(mpStatus) {
      if (!mpStatus) return '';
      const hbStateItems = this.$store.getters['orders/getHbStateItems'];
      const result = hbStateItems.find(el => el.id === mpStatus);
      return result ? result.value : mpStatus;
    }
  }
};
</script>

<style scoped>
  .grey.lighten-3 {
    opacity: 0.6;
  }

  .square-chip {
    border-radius: 0 !important;
  }

  .clickable-iban {
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
  }

  .clickable-iban:hover {
    background-color: rgba(0, 0, 0, 0.05);
    transform: translateY(-1px);
  }

  .clickable-iban:active {
    transform: translateY(0);
  }

  .order-modal .v-card__title {
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .order-modal .caption {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .order-modal .body-2 {
    margin-top: 4px;
  }

  .order-modal .v-card {
    transition: all 0.3s ease;
  }

  .order-modal .v-card:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }

  .note-display-card {
    background-color: #f5f5f5;
    border-left: 4px solid #1976d2 !important;
  }

  .note-display-card .body-2 {
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .note-edit-btn {
    position: absolute !important;
    top: 4px;
    right: 4px;
  }
</style>